<template>
  <div class="vm-avatar-stack flex-box flex-direction-row-reverse">
    <pic
      v-for="(item,i) in users"
      :key="i"
      class="avatar-img"
      :src="item.avatar"
      :width="w"
      :height="h"
    ></pic>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    w: {
      default: function() {
        return 16;
      }
    },
    h: {
      default: function() {
        return 16;
      }
    },
    users: {
      default: function() {
        return [];
      }
    }
  },
  data() {
    return {};
  },
  computed: {},
  mounted() {}
};
</script>

<style lang="stylus" scoped>
.vm-avatar-stack {
  .avatar-img {
    width: 16px;
    height: 16px;
    border-radius: 100px;
    border: 1px solid $white;
    box-sizing: border-box;
    margin-left: -3px;

    &:last-child {
      margin-left: 0px;
    }
  }
}
</style>
